import { ActionIcon, Box, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus as AddIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Abstract } from '@/module/Author/Abstract';
import { AbstractCard } from '@/module/Author/Abstract/components/Card/AbstractCard';

import { NoContentPlaceholder } from '@/core/components';

import { useFilterAvailable } from './hooks/useFilterAvailable';

interface CriteriaAbstractSelectAddModalProps {
  available: Abstract[];
  selected: Abstract[];

  close: () => void;
  onAdd: (abstract: Abstract) => void;
}

export function CriteriaAbstractSelectAddModal({
  available,
  selected,
  close,
  onAdd,
}: CriteriaAbstractSelectAddModalProps) {
  const { t } = useTranslation();
  const { searchProps, options } = useFilterAvailable({ available, selected });

  return (
    <Modal
      size="70vw"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <Box p="sm">
        <Text
          fw="500"
          size="lg"
        >
          Articole
        </Text>
        <TextInput
          label="caută după titlu și autori"
          {...searchProps}
        />
      </Box>
      <Box
        mah="70vh"
        style={{ overflow: 'scroll' }}
      >
        {options.length === 0 && <NoContentPlaceholder title="Nu exista date" />}
        <Stack p="sm">
          {options.map(abstract => (
            <Flex
              align="center"
              key={abstract.id}
            >
              <ActionIcon
                mr="5px"
                onClick={() => onAdd(abstract)}
                variant="filled"
                aria-label={t('button.add')}
              >
                <AddIcon
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
              <AbstractCard
                abstract={abstract}
                onClick={() => window.open(`/author/abstract/${abstract.id}`)}
              />
            </Flex>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
